function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-12,.cls-17,.cls-18,.cls-19,.cls-2,.cls-3,.cls-5{fill:none;}.cls-2{stroke:#e5e5e5;}.cls-12,.cls-17,.cls-19,.cls-2,.cls-3,.cls-5{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3{stroke-width:3.06px;}.cls-3{stroke:#909090;}.cls-4{fill:#fefddb;}.cls-5{stroke:#9ef5ee;stroke-width:5.14px;}.cls-6{fill:#9ef5ee;}.cls-7{fill:#ed8936;}.cls-11,.cls-8{fill:#8ce08c;}.cls-9{fill:#777;}.cls-10{fill:#383838;}.cls-11,.cls-16{fill-rule:evenodd;}.cls-12,.cls-17{stroke:#2b7c63;}.cls-12{stroke-width:3.09px;}.cls-13{fill:#2b7c63;}.cls-14{fill:#fff;}.cls-15,.cls-16{fill:#c2c2c2;}.cls-17,.cls-18{stroke-width:4px;}.cls-18{stroke:#ed8936;stroke-miterlimit:10;}.cls-19{stroke:#fff;stroke-width:16.23px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "vector"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M767.76,154.27c60,69.26,75.71,172.88,65.42,259.58-10.29,86.52-46.4,156.3-89.14,215.09-42.57,58.61-91.76,106.24-150.72,128.39s-127.7,18.84-218.76,13.26S170.29,757,105,696.1C39.8,635,22.53,521.13,51.49,425.71,80.62,330.29,156,253.18,238.15,187.76S409.28,68.44,506.09,59C602.91,49.78,707.58,84.84,767.76,154.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M1.53,353.29c0-129,104.57-233.58,233.57-233.58S468.67,224.29,468.67,353.29,364.1,586.86,235.1,586.86,1.53,482.28,1.53,353.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M126.52,799.75c0-68.14-37.52-180.31-65.63-209"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M129.82,806.85c0-76,95.24-194.73,148.32-223.85"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 156.19,
  width: 573.9,
  height: 360.24
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M128.52,164.8c57.39,0,57.39,102,114.78,102s57.38-102,114.77-102,57.39,102,114.78,102,57.39-102,114.78-102,57.4,102,114.79,102"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "183.05 9.9 168.11 35.78 197.99 35.78 183.05 9.9"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 220.77,
  cy: 21.84,
  r: 14.33
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 248.28,
  y: 8.69,
  width: 27.09,
  height: 27.09
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-2",
  x1: 126.22,
  y1: 46.78,
  x2: 730.7,
  y2: 46.78
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "716.2 487.27 735.34 858.67 694.98 861.05 612.37 571.82 716.2 487.27"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M705.1,858.67c-14,0-48.8,1.74-70.69,38.89H735.34V858.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M723.43,627.53,716.2,487.27,612.37,571.82l36.71,128.53C672.78,672.72,701.25,642.33,723.43,627.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M606.2,178.27a41,41,0,1,1,30,49.61A41,41,0,0,1,606.2,178.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M712.31,169.94a24.58,24.58,0,1,1,18,29.74A24.58,24.58,0,0,1,712.31,169.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M424.6,354.13a24.58,24.58,0,1,1,18,29.73A24.57,24.57,0,0,1,424.6,354.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M620.89,173.15c.84-3.44,2.82-5.91,4.42-5.52s2.22,3.5,1.37,6.94-2.82,5.9-4.42,5.51S620,176.58,620.89,173.15Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-13",
  x: 670.92,
  y: 70.3,
  width: 19.48,
  height: 73.69,
  rx: 9.74,
  transform: "translate(1248.07 498.06) rotate(-154.38)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 680.01,
  y: 83.24,
  width: 3.48,
  height: 22.75,
  rx: 1.74,
  transform: "translate(1255.56 474.72) rotate(-154.38)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M479.68,744.22c-14,0-48.8,1.74-70.69,38.89H509.92V744.22Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 376.03,
  y: 782.83,
  width: 170.41,
  height: 111.5
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M643.51,245c83.77,0,87.08,198.09,74.56,209.22s-123.25,11.13-134.94,0S571.06,245,643.51,245Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M584.51,475.67c11.08,1,105.69,8.47,130.47,1.91,23.17,57.79,9.84,130.54-57.73,130.54-15.67,0-127.39-11.08-140.1-18.92-1.27,16.52-7.2,156.11-7.2,156.11H468.89S417.6,529.68,417.6,520.57C417.6,497.7,535.16,471.37,584.51,475.67Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-17",
  x: 419.35,
  y: 114.92,
  width: 92.66,
  height: 57.67,
  rx: 9.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-18",
  x: 475.91,
  y: 84.51,
  width: 92.66,
  height: 57.67,
  rx: 9.35
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M158.19,785.5a51.16,51.16,0,0,1-63.34,0c-14.68,11.28-24.31,30.18-24.31,51.59,0,34.56,25.06,62.57,56,62.57s56-28,56-62.57C182.5,815.68,172.87,796.78,158.19,785.5Z"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-5",
  points: "722.87 394.2 671.29 362.83 669.03 462.23"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-5",
  points: "578.29 378.33 673.69 282.94 608.46 265.46"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M602,346c5-28.51,13.57-55.57,27-72.54"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-6",
  cx: 41.6,
  cy: 591.68,
  r: 34.21
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-6",
  cx: 73.75,
  cy: 683.49,
  r: 19.95
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-6",
  cx: 129.91,
  cy: 685.66,
  r: 15.26
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "230.23 563.41 252.65 647.06 313.89 585.82 230.23 563.41"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "184.14 689.45 210.57 720.01 223.82 681.84 184.14 689.45"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "129.81 606.11 179.91 664.02 205.02 591.68 129.81 606.11"
})));

var SvgWatermelonPackIllustration14 = function SvgWatermelonPackIllustration14(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 836.11 899.66",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatermelonPackIllustration14, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watermelon-pack-illustration-14.819f8b7f.svg";
export { ForwardRef as ReactComponent };